import { HeaderData } from './header-data.interface';

export enum HeaderType {
  DEFAULT = 'default',
  SESSION_FORM = 'session-form',
  SESSION_VIEW = 'session-view',
  DISCUSSION = 'discussion',
  ITEMS_PREVIEW = 'items-preview',
  AI_TEMPLATE = 'ai-template',
}

export enum HeaderTab {
  GENERAL = 'general',
  TEAMS = 'teams',
  PEOPLE = 'people',
  CONTENT = 'content',
  LOG = 'LOG',
  VOTE_TEAM = 'VOTE_TEAM',
  VOTE_ALL = 'VOTE_ALL',
  FORUM = 'FORUM',
  CHAT = 'CHAT',
}

export class HeaderTypeRequest {
  type: HeaderType;
  tab?: HeaderTab;
  data?: HeaderData;
}
